module.exports = __webpack_public_path__ + "img/icon-at-symbol.2a278841.svg";